import React from 'react';
import { Helmet } from 'react-helmet';
import { images } from '../../constants';
import WorkWithLogos from '../../components/IconScroll/WorkWithLogos';
import { renderTextWithLinks } from '../../components/TextLinks';
import './Hero.css';
import { useLanguage } from '../../constants/localisations/language_context';
import { LANG_ENG } from '../../constants/strings';

const Hero = () => {
  const { currentLanguage } = useLanguage();
  const handleButtonClick = () => {
    window.location.href = '/chatgpt-kurs'; // Redirect to '/chatgpt-kurs' on button click
  };

  const handleCallClick = () => {
    window.location.href = "tel:+46729449238";
  };

  const heroText = currentLanguage === LANG_ENG ? "Your AI consultant, helping your company navigate the AI jungle" : "Din AI-konsult som hjälper ditt företag navigera i AI-djungeln";

  const p1 = currentLanguage === LANG_ENG ? "Tired of repetitive tasks? Techlära is here to make your life easier with the latest AI technology." : "Trött på repetativa uppgifter? Techlära är här för att underlätta din vardag med den senaste AI-tekniken.";
  const p2 = currentLanguage === LANG_ENG ? "In a time where technological advancements happen faster than ever, many companies face the challenge of identifying the right tools that not only meet their current needs but also foster long-term growth and innovation. This is where we can make a difference." : "I en tid där teknologiska framsteg sker snabbare än någonsin står många företag inför utmaningen att identifiera de rätta verktygen som inte bara uppfyller era aktuella behov utan också främjar långsiktig tillväxt och innovation. Det är här vi kan göra skillnad.";
  // Markdown link syntax rather than JSX so the sentence stays one translatable
  // string; renderTextWithLinks turns it into real links.
  const pLinks = currentLanguage === LANG_ENG
    ? "We build [AI agents](/ainews/ai-agents-what-are-they-and-how-do-they-work), [chatbots](/chatbot) and automations for companies — most often with [Claude from Anthropic](/claude), the model we reach for on multi-step work. Read more about what an [AI consultant](/aiconsultant) actually does."
    : "Vi bygger [AI-agenter](/ainyheter/ai-agenter-vad-r-det-och-hur-fungerar-de), [chatbottar](/chatbot) och automatiseringar åt företag — oftast med [Claude från Anthropic](/claude), modellen vi väljer när uppgiften har flera steg. Läs mer om vad en [AI-konsult](/aikonsult) faktiskt gör.";

  const p3 = currentLanguage === LANG_ENG ? "Check out our ChatGPT course! " : "Titta in vår kurs i ChatGPT! ";
  const buttonText = currentLanguage === LANG_ENG ? "Titta in kursen" : "Titta in kursen";
  const callButtonText = currentLanguage === LANG_ENG ? "Call me" : "Ring mig";
  
  const heroAlt = currentLanguage === LANG_ENG ? "Techlära - AI consulting and courses" : "Techlära - AI-konsult och AI-kurser";

  return (
    <div className="hero">
      {/* The hero image is the homepage LCP element. The <img> below is eager +
          fetchpriority="high", but the browser still has to parse the markup to
          find it; this preload sits in <head> of the prerendered HTML (react-snap
          snapshots Helmet output) so the request starts with the first bytes. */}
      <Helmet>
        <link rel="preload" as="image" href={images.hero} fetchpriority="high" />
      </Helmet>
      <div className="row align-items-center">
        <div className="col-md-6 col-12">
          <h1 className="title"> {heroText} </h1>
           <p> {p1} </p>
          <p> {p2} </p>
          <p className="hero-links"> {renderTextWithLinks(pLinks)} </p>
          {currentLanguage !== LANG_ENG && 
          <p> {p3} </p>
          }
          {currentLanguage !== LANG_ENG && 
          <button className="btn-green btn-left" onClick={ handleButtonClick }> {buttonText} </button>
          }
          <button className="btn-green" onClick={ handleCallClick }> {callButtonText} </button>
        </div>
        <div className="col-md-6 col-12 mt-md-0 mt-4">
          {/* No loading="lazy" here: on mobile this is the largest element in
              (or just below) the fold, and lazy-loading it pushed LCP out to ~9s
              because the request only started after layout. width/height match
              the asset (1000x1000) so the box is reserved before it arrives. */}
          <img
            className="img-fluid"
            src={images.hero}
            alt={heroAlt}
            title={heroAlt}
            width={1000}
            height={1000}
            fetchpriority="high"
            decoding="async"
          />
        </div>
      </div>
      <WorkWithLogos />
    </div>
    
  )
}

export default Hero